export enum ResponseMessage {
  AUTHENTICATION_FAILED = 'Authentication failed.',
}
